import ArticlesPage from "./pages/ArticlesPage";

function App() {
  return <ArticlesPage />;
}

export default App;
